import React, { useContext, useRef, useState, useEffect } from 'react';
import {
  Button,
  Checkbox,
  InfoBox,
  Input,
  MobileTabBar,
  Phone,
  SelectFile,
  SelectTextImage,
  EditableTextarea,
  SelectGroupList,
  MessageTemplateList
} from 'components';
import MessagesSummary from '../messages-summary';
import ArrowLeft from 'assests/icons/arrow-left';
import ArrowRight from 'assests/icons/arrow-right';
import PlusIcon from 'assests/icons/plus.icon';
import ParametersIcon from 'assests/icons/parameters.icon';
import { Row, Col, Tabs, Form, Dropdown ,Modal,Radio, message} from 'antd';
import { useDebounce,useDebouncedCallback  } from 'use-debounce';

import './text-message.less';
import { DimensionsContext } from 'context/dimensions.context';
import classNames from 'classnames';

import {uploadMms,removeMms} from 'services/mms.service';
import {getSmsPart, getEtkMessage,getTotalCreditByType} from 'services/info.service';
import { customMessages } from 'utils';
import {serverUrl } from '../../../config';
import { uploadParameterFile } from 'services/parameter.service';
import { useJob } from 'context/job.context';

import * as contactService from 'services/contact.service';
import * as infoService from 'services/info.service';
import * as phonebookService from 'services/phonebook.service';
import SelectCircles from 'components/SelectReadyMesssages/select-circles';

const defaultMessageProps= 
{
  remainingCharacterCount:0,
  availableCharacterCount:160,
  smsPartCount:1,
  etkSmsPartCount:1 
};

const TextMessage = (props) => {
  
  const { currentJob, setCurrentJob } = useJob();
  const { TabPane } = Tabs;
  const [form] = Form.useForm();
  const { isPc, isTabletBig } = useContext(DimensionsContext);

  const [activeTab, setActiveTab] = useState(currentJob?.messageType ? "" + currentJob?.messageType  : "0");
  const [valid, setValid] = useState(false);
  const [receivers, setReceivers] = useState(0);
  const [etkMessage, setEtkMessage] = useState('');
  const [etkFlag, setEtkFlag] = useState(currentJob?.etkFlag ?? null);
  const [toBeSaved, setToBeSaved] = useState(currentJob?.toBeSaved ??  false);
  const [messageText, setMessageText] = useState(currentJob?.messageWithoutEtk ??  null);
  const [messageProps, setMessageProps] = useState(defaultMessageProps);

  const [paramHeaders, setParamHeaders] = useState(["E-Posta","Ad","Meslek"]);
  const [firstRow, setFirstRow] = useState([]);
  const [isParamValid, setParamValid] = useState(null);
  const [mmsFile, setMmsFile] = useState(null);
  const [mmsPreview, setMmsPreview] = useState(null);
  const [messageType, setMessageType] = useState(currentJob?.messageType ??  0);

  const [selectedRadio, setSelectedRadio] = useState(1);
  const [electronicMessage, setElectronicMessage] = useState(false);

  const [circles, setCircles] = useState([]);
  const [paramType, setParamType] = useState(currentJob?.paramType ? currentJob?.paramType : 1);

  const delayedOnValuesChange = useDebouncedCallback(
    // function
    (a,b) => {
      setValid(false);
      console.log("delayed");
      form.validateFields().then(values => {
        
      var e =values.messageText ? values.messageText.trim() : "";
      
      const UNICODE_TURKISH_REGEXP =  /[^\u0000-\u007F|ØøÅåΔΦΓΠΨΣΞÆ£¥èéùìòæßÉ¤ÄÑà¡ñ§¿äışğüçöİŞĞÜÇÖ€\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3]/g
      if (e.match(UNICODE_TURKISH_REGEXP)) {
        Modal.error({
          title: 'Hata',
          content: 'Mesaj metninizde gönderimi desteklenmeyen karakterler "?" ile güncellenmiştir. Lütfen gönderim yapmadan önce mesaj metninizi düzenleyiniz.',
        });
      }
      e=  e.replace(UNICODE_TURKISH_REGEXP,"?");
      form.setFieldsValue({
        messageText:  e
      });
        var message =e;
        if (values.etkFlag)
        {
          message = message + etkMessage;
          
        }
        var previewMessage = message;
        if (messageType==3)
        {
          // const ASCII_REGEX = /[\x00-\x1F]/;
          // message= message.replace(ASCII_REGEX, "");
            paramHeaders.map((item, index) => {
              
              previewMessage = previewMessage.replaceAll('%' + item + '%' , firstRow ? (firstRow[index]==null ? '' :  firstRow[index]  ) : '');
            
            });
          
           
        }
        setMessageText(previewMessage);
        var data={};
        data.smsText=e;
        data.etkFlag=values.etkFlag;
        getSmsPart(data).then((res) => {
         setMessageProps(res);
         if (etkFlag==null)
         {
          setValid(false);
         }
        else
        {
          setValid(true);
        }
        })
        .catch((response) => {
          Modal.error({
            title: 'Hata',
            content: customMessages.getMessage(response.responseCode),
          });
        });
        
      }).catch(
        errorInfo => {  
          setValid(false);
      });
    },
    // delay in ms
    500
  );


  function onChangeTabs(key) {
    setValid(false);
    setActiveTab(key);
    setMessageType(key);
    setMessageText("");
    setMmsFile(null);
    setMessageProps(defaultMessageProps);
    form.resetFields();
  }

  function onSelectedTemplate(message) {
    setMessageText(message);
    form.setFieldsValue({
      messageText: message
    });
  }

 
  function onGetEtkMessage()
  {
    getEtkMessage().then((res) => {
      setEtkMessage(res.properties.etkMessage);
      debouncedOnChange(messageText);
    })
    .catch((response) => {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(response.responseCode),
      });
    });
  }



  const debouncedOnChange = useDebouncedCallback(
    // function
    (e) => {
        if (e)
        {
          // if (messageType==3)
          // {
          // const ASCII_REGEX = /[\x00-\x1F]/;
          // e= e.replace(ASCII_REGEX, "");
          // }
      const UNICODE_TURKISH_REGEXP =  /[^\u0000-\u007F|ØøÅåΔΦΓΠΨΣΞÆ£¥èéùìòæßÉ¤ÄÑà¡ñ§¿äışğüçöİŞĞÜÇÖ€\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3]/g
      if (e.match(UNICODE_TURKISH_REGEXP)) {
        Modal.error({
          title: 'Hata',
          content: 'Mesaj metninizde gönderimi desteklenmeyen karakterler “?” ile güncellenmiştir. Lütfen gönderim yapmadan önce mesaj metninizi düzenleyiniz.',
        });
      }
      e=  e.replace(UNICODE_TURKISH_REGEXP,"?");
      form.setFieldsValue({
        messageText:  e
      });
      
        var etkCurrent = etkFlag ? etkFlag : false;
        var message =e;
        if (message)
        {
        if (etkCurrent)
        {
          message = message + etkMessage;
        } 
        //const regex = /(<([^>]+)>)/ig;
        var previewMessage = message;
        if (messageType==3)
        {
            paramHeaders.map((item, index) => {
              previewMessage = previewMessage.replaceAll('%' + item + '%' , firstRow ? (firstRow[index]==null ? '' :  firstRow[index]  )  : '');
            
            });
            
        }
        setMessageText(previewMessage);
      var data={};
      data.smsText=e;
      data.etkFlag=etkCurrent ;
      getSmsPart(data).then((res) => {
        setMessageProps(res);
        if (etkFlag==null)
        {
         setValid(false);
        }
       else
       {
         setValid(true);
       }
      })
      .catch((response) => {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(response.responseCode),
        });
      });
    }
  }
    },
    // delay in ms
    500
  );


  const onNext =()=> {
    form.validateFields().then(values => {
      values.maxCredit=0;
      values.messageWithoutEtk=values.messageText ? values.messageText.trim() : "";
      values.messageType=messageType;
      values.messageText=messageText.trim();
      values.toBeSaved=toBeSaved;
      values.receivers=receivers;
      values.paramType = paramType;
      if (messageType==3)
      {
        var data = {
          smsText:currentJob?.messageWithoutEtk,
          etkFlag:currentJob?.etkFlag,
          type:paramType=="1"? 'param': 'rehber',
          messageType:messageType
        };
        infoService.getTotalCreditByType(data).then((res)=> 
        {
          if (res.totalCredit<1)
          {
            Modal.error({
              title: 'Hata',
              content: customMessages.getMessage('zeroCreditUsage'),
            });
            return;
          }
          values.maxCredit=res.totalCredit;
          setCurrentJob({...currentJob,...values});
          props.updateCurrent(3);
        }).catch((err)=>
          {
            Modal.error({
              title: 'Hata',
              content: customMessages.getMessage(err.responseCode),
            });
          }
        );
      }
      else
      {
      setCurrentJob({...currentJob,...values});
     // props.updateData(values);
      props.updateCurrent(2);
    }
    });
     
  }

  useEffect(() => {
    onGetEtkMessage();
    delayedOnValuesChange();
   
   
  }, []);

  useEffect(() => {
    delayedOnValuesChange();    
  }, [etkFlag]);

  

  
  const onMMSFileUpload = (e) => {
    const mmsFile= e.target.files[0];
    if (mmsFile)
    {
      uploadMms(mmsFile).then((res) => {
        setMmsFile(mmsFile);
        setMmsPreview(URL.createObjectURL(mmsFile));
      })
      .catch((response) => {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(response.responseCode),
        });
        onMMSFileRemove();
      });
    }
   }
   

   
  const onMMSFileRemove = () => {
    removeMms().then()
    .catch((response) => {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(response.responseCode),
      });
    });
   }

   const onParamFileUpload = (e) => {
    const file= e.target.files[0];
    if (file)
    {
      uploadParameterFile(file).then((res) => {
        setParamValid(true);
        setParamHeaders(res.properties.header);
        setFirstRow(res.properties.firstRow);
        setReceivers(res.properties.rowCount);
        //setMmsPreview(URL.createObjectURL(mmsFile));
      })
      .catch((response) => {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(response.responseCode),
        });
      });
    }
   }

   
  function fetchCircle() {
    contactService.getCircles()
      .then((result) => {
        setCircles(result.circle);
      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }

  function onContactListChange(item) {
    phonebookService.uploadRecipients({circles:[item.id]})
      .then((result) => {
        infoService.getRecipientsByType("rehber").then((res) => {
          setParamHeaders(res.properties.header);
          setFirstRow(res.properties.firstRow);
          setReceivers(res.properties.size);
          setParamValid(true);
        }).catch((err) => {
          message.error(customMessages.getMessage(err.responseCode));
        });

        
      }).catch((err) => {
        message.error(customMessages.getMessage(err.responseCode));
      });
  }
  
  
  
  useEffect(() => {
    fetchCircle();
  }, []);


  return (
   
      <div className="text-message-page">
        <div className="container">
          <Form
            form={form}
            name="text-messages"
          >
            <div
              className={classNames('step-transitions', {
                'padding-spaces-none': !isPc,
              })}
            >
              <div className="step-transitions__left">
                <Tabs
                  defaultActiveKey={messageType}
                  onChange={onChangeTabs}
                  renderTabBar={(props, Item) => {
                    return isPc ? (
                      <Item {...props} />
                    ) : (
                      <MobileTabBar props={props} item={Item} />
                    );
                  }}
                >
                  <TabPane tab="Kısa Mesaj (SMS)" key="0"></TabPane>
                  <TabPane tab="Zengin İçerikli Mesaj" key="1"></TabPane>
                  <TabPane tab="Kişiye Özel Mesaj" key="3"></TabPane>
                </Tabs>
              </div>
              {isPc ? (
                <div className="step-transitions__right">
                  <Button type="ghost" className="circle"  
                     onClick={()=>  props.updateCurrent(0)}
                     >
                    <ArrowLeft />
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="ant-btn--icon"
                    onClick={onNext}
                    disabled={!valid}
                  >
                    Alıcı Seçin
                    <ArrowRight />
                  </Button>
                </div>
              ) : null}
            </div>
            <Row className="page-content">
              <Col d={24} lg={24} xl={16} span={24}>
                <Tabs
                  activeKey={activeTab}
                  defaultActiveKey={activeTab}
                  renderTabBar={(props) => <></>}
                >
                  <TabPane tab="Kısa Mesaj (SMS)" key="0">
                    {activeTab == 0 && (
                      <>
                        <InfoBox
                          type="warning"
                          content={
                            <p>
                              Müşterilerinize kampanya duyurularınızı uygun
                              fiyatlı ve etkili bir şeklide ulaştırabilmek için{' '}
                              <strong>SMS</strong> seçeneğini tercih
                              edebilirsiniz.
                            </p>
                          }
                        />
                        <Row className="message-preparing">
                          <Col md={24} lg={24} xl={12} span={24}>
                            <div className="message-preparing__left">
                              <h3 className="box__title">
                                SMS Mesajınızı Hazırlayın
                              </h3>
                              <h4 className="box__title--small">Mesajınız</h4>
                              <MessageTemplateList  onChange={onSelectedTemplate} />
                              <span className="info-text--big text-center">
                                veya
                              </span>
                              <Form.Item initialValue={messageText}
                                rules={[{ required: true }]}
                                name="messageText"
                              >
                                <Input.TextArea onChange={(e)=>debouncedOnChange(e.target.value)} value={messageText}
                                  autoComplete="off" maxLength={765}
                                  placeholder="Mesajınızı yazın"
                                  showChar
                                 
                                />
        
                              </Form.Item>
                            
                              <div className="text-info">
                              <div>
                                <span>Karakter: <strong className="value">{messageProps.remainingCharacterCount}/{messageProps.availableCharacterCount}</strong></span>
                                <span style={{float:'right'}}>SMS Sayısı: <strong>{messageProps.etkSmsPartCount}</strong> </span>
                              </div>
                              
                            </div>
                              
                              
                             <InfoBox
                                compClass="visible"
                                content={
                                  <>
                                    <Form.Item
                                      valuePropName="checked"
                                      name="toBeSaved"
                                      initialValue={toBeSaved}
                                    >
                                      <Checkbox  onChange={(e)=> setToBeSaved(e.target.checked)}
                                        text={
                                          <>
                                            <h6 className="info-box__title">
                                              Mesajı gönderdikten sonra hazır
                                              mesajlarıma kaydet
                                            </h6>
                                          </>
                                        }
                                      />
                                    </Form.Item>
                                  </>
                                }
                              /> 
                              <span className='box__title--xsmall'>Lütfen mesaj içeriğine uygun seçim yapınız</span>
                            <Form.Item name="etkFlag" initialValue={etkFlag}    rules={[{ required: true }]}>
                              <Radio.Group className="radio-group--v3" onChange={(e) => {
                                setSelectedRadio(e.target.value);
                                setEtkFlag(e.target.value);
                              }} value={selectedRadio}>
                                <InfoBox compClass="visible"
                                         content={<>
                                           <Radio value={true}>
                                             <h6 className='info-box__title'>Ticari İletişim Mesajı</h6>
                                             <p>Ticari Elektronik İleti Yönetim Sistemi’nde (İYS) kayıtlı izinli veri tabanınıza gönderim yapabilirsiniz.</p>
                                           </Radio>
                                         </>
                                         }
                                />
                                <Modal
                                  title="Ticari Elektronik İleti"
                                  visible={ electronicMessage }
                                  onCancel={ () => setElectronicMessage(false) }
                                  footer={[
                                    <div className="modal-action">
                                      <Button
                                        key="confirm"
                                        shape="round"
                                        type="ghost"
                                        onClick={ () => {
                                          setElectronicMessage(false)
                                        } }
                                      >
                                        Tamam
                                      </Button>
                                    </div>
                                  ]}>
                                  <InfoBox content={<><p className="info-text--big">6563 sayılı Elektronik Ticaret Kanunu gereğince, göndereceğiniz her ticari SMS’te, müşterilerinize SMS reddetme hakkı sunmanız zorunludur. Size özel ücretsiz sunulan bu özelliği kullanmanız tavsiye edilir.</p></>
                                  }
                                  />
                                </Modal>
                                <InfoBox compClass="visible"
                                         content={<>
                                           <Radio value={false}>
                                             <h6 className='info-box__title'>Bilgilendirme Mesajı</h6>
                                             <p>Genel bilgilendirme mesajlarını izinli veri tabanı kontrolüne gerek olmadan listenizdeki tüm kişilere gönderebilirsiniz.</p>
                                           </Radio>
                                         </>
                                         }
                                />
                              </Radio.Group>
                            </Form.Item>
                            <p className='info-text--small'>Ticari iletişim ve Bilgilendirme mesaj gönderimlerinizde;<br/><br/>
                              Kurumsal gönderimlerinizde şirketinize ait MERSIS numarasını, bireysel gönderimlerde ise TC Kimlik Numaranızı mesajlarınıza eklemeniz gerekmektedir. SMS içeriğinde şirketinizin iletişim bilgilerine yer verilmelidir. Ticari elektronik iletinin niteliği içeriğinden açık bir biçimde anlaşılamıyorsa tanıtım, kampanya ve bilgilendirme gibi niteliği belirleyici bir ibareye iletinin başlangıcında yer verilmelidir.
                            </p>
                            </div>
                          </Col>
                          <Col md={{ span: 11 }} xl={12} span={24}>
                            <div className="message-preparing__center">
                              <Tabs defaultActiveKey="1">
                                e
                                <TabPane tab="Mesaj Detayı" key="1">
                                  <Phone
                                    title={currentJob?.sender}
                                    message={messageText ? <>
                                      <p>
                                      {messageText}
                                      </p>
                                    </> :""
                                    }
                                  />
                                </TabPane>
                                <TabPane tab="Bildirim" key="2">
                                  <Phone lockScreen  title={currentJob?.sender}  message={messageText} />
                                </TabPane>
                              </Tabs>
                            </div>
                          </Col>
                          {!isTabletBig ? (
                            <Col md={{ span: 11, offset: 2 }} span={24}>
                              <div className="message-preparing__right">
                                <MessagesSummary
                                    title={currentJob?.sender}
                                    message={messageText}
                                    receivers={receivers}
                                    reportName={currentJob?.campaignName}
                                    
                                />
                              </div>
                            </Col>
                          ) : null}
                        </Row>
                      </>
                    )}
                  </TabPane>
                  <TabPane tab="Zengin İçerikli Mesaj" key="1">
                    {activeTab == 1 && (
                      <>
                        <InfoBox
                          type="warning"
                          content={
                            <p>
                              Müşterilerinize <strong>video</strong> veya{' '}
                              <strong>fotoğraf</strong> içeriği bulunan mesajlar
                              gönderebilmek için{' '}
                              <strong>Zengin İçerikli Mesaj</strong> seçeneğini
                              tercih edebilirsiniz.
                            </p>
                          }
                        />
                        <Row className="message-preparing">
                          <Col md={24} lg={24} xl={12} span={24}>
                            <div className="message-preparing__left">
                              <h3 className="box__title">
                                Zengin İçerikli Mesajınızı Hazırlayın
                              </h3>
                              <h4 className="box__title--small">
                                Mesaj Görseliniz
                              </h4>
                              <Form.Item
                                rules={[{ required: true }]}
                                name="select-image"
                              >
                                <SelectTextImage onChange={onMMSFileUpload} onRemoveFile={onMMSFileRemove}  allowExtensions={["jpg", "jpeg", "png", "gif", "mp3", "3gp", "mp4"]}  errorMessage={customMessages.getMessage("202")} />
                              </Form.Item>
                              <h4 className="box__title--small">Mesajınız</h4>
                              <Form.Item initialValue={messageText}
                                
                                name="messageText"
                              >
                                <Input.TextArea  onChange={(e)=>debouncedOnChange(e.target.value)} 
                                  autoComplete="off" maxLength={500}
                                  placeholder="Mesajınızı yazın"
                                  showChar
                                /> 
                              </Form.Item>
                              <div className="text-info">
                                  <div>
                                    <span>Karakter: <strong className="value">{messageProps.remainingCharacterCount}/{messageType == 3 ? 500 :  messageProps.availableCharacterCount}</strong></span>
                                    <span style={{float:'right'}}>SMS Sayısı: <strong>{messageProps.etkSmsPartCount}</strong> </span>
                                  </div>
                                  
                                </div>
                             
                              {/* <InfoBox
                                compClass="visible"
                                content={
                                  <>
                                    <Form.Item
                                      valuePropName="checked"
                                      name="toBeSaved"
                                      initialValue={toBeSaved}
                                    >
                                       <Checkbox  onChange={(e)=> setToBeSaved(e.target.checked)}
                                        text={
                                          <>
                                            <h6 className="info-box__title">
                                              Mesajı gönderdikten sonra hazır
                                              mesajlarıma kaydet
                                            </h6>
                                          </>
                                        }
                                      />
                                    </Form.Item>
                                  </>
                                } 
                              />*/}
                              <span className='box__title--xsmall'>Lütfen mesaj içeriğine uygun seçim yapınız</span>
                              <Form.Item name="etkFlag" initialValue={etkFlag}    rules={[{ required: true }]}>
                              <Radio.Group className="radio-group--v3" onChange={(e) => {
                                setSelectedRadio(e.target.value);
                                setEtkFlag(e.target.value);
                              }} value={selectedRadio}>
                                <InfoBox compClass="visible"
                                         content={<>
                                           <Radio value={true}>
                                             <h6 className='info-box__title'>Ticari İletişim Mesajı</h6>
                                             <p>Ticari Elektronik İleti Yönetim Sistemi’nde (İYS) kayıtlı izinli veri tabanınıza gönderim yapabilirsiniz.</p>
                                           </Radio>
                                         </>
                                         }
                                />
                                <Modal
                                  title="Ticari Elektronik İleti"
                                  visible={ electronicMessage }
                                  onCancel={ () => setElectronicMessage(false) }
                                  footer={[
                                    <div className="modal-action">
                                      <Button
                                        key="confirm"
                                        shape="round"
                                        type="ghost"
                                        onClick={ () => {
                                          setElectronicMessage(false)
                                        } }
                                      >
                                        Tamam
                                      </Button>
                                    </div>
                                  ]}>
                                  <InfoBox content={<><p className="info-text--big">6563 sayılı Elektronik Ticaret Kanunu gereğince, göndereceğiniz her ticari SMS’te, müşterilerinize SMS reddetme hakkı sunmanız zorunludur. Size özel ücretsiz sunulan bu özelliği kullanmanız tavsiye edilir.</p></>
                                  }
                                  />
                                </Modal>
                                <InfoBox compClass="visible"
                                         content={<>
                                           <Radio value={false}>
                                             <h6 className='info-box__title'>Bilgilendirme Mesajı</h6>
                                             <p>Genel bilgilendirme mesajlarını izinli veri tabanı kontrolüne gerek olmadan listenizdeki tüm kişilere gönderebilirsiniz.</p>
                                           </Radio>
                                         </>
                                         }
                                />
                              </Radio.Group>
                            </Form.Item>
                            <p className='info-text--small'>Ticari iletişim ve Bilgilendirme mesaj gönderimlerinizde;<br/><br/>
                              Kurumsal gönderimlerinizde şirketinize ait MERSIS numarasını, bireysel gönderimlerde ise TC Kimlik Numaranızı mesajlarınıza eklemeniz gerekmektedir. SMS içeriğinde şirketinizin iletişim bilgilerine yer verilmelidir. Ticari elektronik iletinin niteliği içeriğinden açık bir biçimde anlaşılamıyorsa tanıtım, kampanya ve bilgilendirme gibi niteliği belirleyici bir ibareye iletinin başlangıcında yer verilmelidir.
                            </p>
                            </div>
                          </Col>
                          <Col md={{ span: 11 }} xl={12} span={24}>
                            <div className="message-preparing__center">
                              <Tabs defaultActiveKey="1">
                                e
                                <TabPane tab="Mesaj Detayı" key="1">
                                  <Phone
                                    title={currentJob?.sender}
                                    message={
                                      messageText &&  mmsPreview ? (
                                      <>
                                        <p>
                                          {messageText}
                                        </p>
                                        {mmsPreview &&
                                          <figure>
                                            <img src={mmsPreview} />
                                          </figure>
                                        }
                                      </>) : ""
                                    }
                                  />
                                </TabPane>
                                <TabPane tab="Bildirim" key="2">
                                  <Phone lockScreen  title={currentJob?.sender}  message={messageText}/>
                                </TabPane>
                              </Tabs>
                            </div>
                          </Col>
                          {!isTabletBig ? (
                            <Col md={{ span: 11, offset: 2 }} span={24}>
                              <div className="message-preparing__right">
                              <MessagesSummary
                                 title={currentJob?.sender}
                                 message={messageText}
                                 receivers={receivers}
                                 reportName={currentJob?.campaignName}
                                 numbersOfSms={currentJob?.maxCredit}
                                />
                              </div>
                            </Col>
                          ) : null}
                        </Row>
                      </>
                    )}
                  </TabPane>
                  <TabPane tab="Kişiye Özel Mesaj" key="3">
                    {activeTab == 3 && (
                      <>
                        <InfoBox
                          type="warning"
                          content={
                            <p>
                              Müşterilerinize{' '}
                              <strong>
                                programlanabilir, kişiselleştirilebilir
                              </strong>{' '}
                              mesajlar ulaştırabilmek için {' '}
                              <strong>Kişiye Özel Mesaj</strong> seçeneğini
                              tercih edebilirsiniz. <br/>
                              Parametrik gönderim listenizi hazırlamak için örnek Excel dosyasını <strong><a href="/samples/parametrikOrnek.xlsx"> buradan
						indirebilirsiniz.</a></strong>.
						İndireceğiniz dosyanın ilk satırına parametre adı ekleyip çıkarabilir veya örnek parametreleri değiştirebilirsiniz.
                            </p>
                          }
                        />
                        <Row className="message-preparing">
                          <Col md={24} lg={24} xl={12} span={24}>
                            <div className="message-preparing__left">
                              <h3 className="box__title">
                                Kişiye Özel SMS Mesajınızı Hazırlayın
                              </h3>
                              <h4 className="box__title--small">
                                Parametreler
                              </h4>
                              
                      <Radio.Group
                        className="radio-group--v2"
                        onChange={(e) => {
                          setParamType(e.target.value);
                          setReceivers(0);
                          setParamValid(false);
                          setMessageText("");
                          form.resetFields();
                        }}
                        value={paramType}
                      >
                        <Radio value={1}><div className="text-area">Dosyadan Yükle</div>
                        {paramType === 1 ? (   
                          
                           
                         
                              <Form.Item
                                rules={[{ required: true }]}
                                name="select-param"
                              >
                                <SelectFile
                                onChange={onParamFileUpload}
                                  type="file"
                                  title={<span>Parametre Dosyası Yükle</span>}
                                  icon={<ParametersIcon />}
                                />
                              </Form.Item>
                               ) : null}
                        </Radio>
                        <Radio value={2}>
                          <div className="text-area">Rehberimden Seç</div>
                          {paramType === 2 ? (
                            <Form.Item
                              name="group-list"
                            >

                                <SelectCircles   icon={<ParametersIcon />} list={circles} onChange={onContactListChange} />
                            </Form.Item>
                          ) : null}
                        </Radio> </Radio.Group>
                        <h4 className="box__title--small">Mesajınız</h4>
                              <Form.Item initialValue={messageText}
                                rules={[{ required: true }]}
                                name="messageText"
                              >
                                <EditableTextarea disabled={!isParamValid} headers={paramHeaders} firstRow={firstRow} onChange={(e) => debouncedOnChange(e)} />
                              </Form.Item>
                              <div className="text-info">
        <div>
          <span>Karakter: <strong className="value">{messageProps.remainingCharacterCount}/{messageProps.availableCharacterCount}</strong></span>
          <span style={{float:'right'}}>SMS Sayısı: <strong>{messageProps.etkSmsPartCount}</strong> </span>
        </div>
        
      </div>
                              {/* <InfoBox
                                compClass="visible"
                                content={
                                  <>
                                    <Form.Item
                                      valuePropName="checked"
                                      name="toBeSaved"
                                      initialValue={toBeSaved}
                                    >
                                      <Checkbox  onChange={(e)=> setToBeSaved(e.target.checked)}
                                        text={
                                          <>
                                            <h6 className="info-box__title">
                                              Mesajı gönderdikten sonra hazır
                                              mesajlarıma kaydet
                                            </h6>
                                          </>
                                        }
                                      />
                                    </Form.Item>
                                  </>
                                }
                              /> */}
                              <span className='box__title--xsmall'>Lütfen mesaj içeriğine uygun seçim yapınız</span>
                              <Form.Item name="etkFlag" initialValue={etkFlag}    rules={[{ required: true }]}>
                              <Radio.Group className="radio-group--v3" onChange={(e) => {
                                setSelectedRadio(e.target.value);
                                setEtkFlag(e.target.value);
                              }} value={selectedRadio}>
                                <InfoBox compClass="visible"
                                         content={<>
                                           <Radio value={true}>
                                             <h6 className='info-box__title'>Ticari İletişim Mesajı</h6>
                                             <p>Ticari Elektronik İleti Yönetim Sistemi’nde (İYS) kayıtlı izinli veri tabanınıza gönderim yapabilirsiniz.</p>
                                           </Radio>
                                         </>
                                         }
                                />
                                <Modal
                                  title="Ticari Elektronik İleti"
                                  visible={ electronicMessage }
                                  onCancel={ () => setElectronicMessage(false) }
                                  footer={[
                                    <div className="modal-action">
                                      <Button
                                        key="confirm"
                                        shape="round"
                                        type="ghost"
                                        onClick={ () => {
                                          setElectronicMessage(false)
                                        } }
                                      >
                                        Tamam
                                      </Button>
                                    </div>
                                  ]}>
                                  <InfoBox content={<><p className="info-text--big">6563 sayılı Elektronik Ticaret Kanunu gereğince, göndereceğiniz her ticari SMS’te, müşterilerinize SMS reddetme hakkı sunmanız zorunludur. Size özel ücretsiz sunulan bu özelliği kullanmanız tavsiye edilir.</p></>
                                  }
                                  />
                                </Modal>
                                <InfoBox compClass="visible"
                                         content={<>
                                           <Radio value={false}>
                                             <h6 className='info-box__title'>Bilgilendirme Mesajı</h6>
                                             <p>Genel bilgilendirme mesajlarını izinli veri tabanı kontrolüne gerek olmadan listenizdeki tüm kişilere gönderebilirsiniz.</p>
                                           </Radio>
                                         </>
                                         }
                                />
                              </Radio.Group>
                            </Form.Item>
                            <p className='info-text--small'>Ticari iletişim ve Bilgilendirme mesaj gönderimlerinizde;<br/><br/>
                              Kurumsal gönderimlerinizde şirketinize ait MERSIS numarasını, bireysel gönderimlerde ise TC Kimlik Numaranızı mesajlarınıza eklemeniz gerekmektedir. SMS içeriğinde şirketinizin iletişim bilgilerine yer verilmelidir. Ticari elektronik iletinin niteliği içeriğinden açık bir biçimde anlaşılamıyorsa tanıtım, kampanya ve bilgilendirme gibi niteliği belirleyici bir ibareye iletinin başlangıcında yer verilmelidir.
                            </p>
                            </div>
                          </Col>
                          <Col md={{ span: 11 }} xl={12} span={24}>
                            <div className="message-preparing__center">
                              <Tabs defaultActiveKey="1">
                                <TabPane tab="Mesaj Detayı" key="1">
                                  <Phone
                                    title={currentJob?.sender}
                                    message={messageText ? <>
                                      <p>
                                      {messageText}
                                      </p>
                                    </> :""
                                    }
                                  />
                                </TabPane>
                                <TabPane tab="Bildirim" key="2">
                                  <Phone lockScreen   title={currentJob?.sender}  message={messageText}/>
                                </TabPane>
                              </Tabs>
                            </div>
                          </Col>
                          {!isTabletBig ? (
                            <Col md={{ span: 11, offset: 2 }} span={24}>
                              <div className="message-preparing__right">
                              <MessagesSummary
                                
                                title={currentJob?.sender}
                                message={messageText}
                                receivers={receivers}
                                reportName={currentJob?.campaignName}
                                />
                              </div>
                            </Col>
                          ) : null}
                        </Row>
                      </>
                    )}
                  </TabPane>
                </Tabs>
              </Col>
              {isTabletBig ? (
                <Col
                  s={24}
                  md={12}
                  lg={12}
                  xl={{ span: 6, offset: 2 }}
                  span={24}
                >
                  <div className="message-preparing__right">
                  <MessagesSummary
                                  
                                  title={currentJob?.sender}
                                  message={messageText}
                                  receivers={receivers}
                                  reportName={currentJob?.campaignName}
                    />
                  </div>
                </Col>
              ) : null}
              {!isPc ? (
                <div className="step-transitions__right">
                  <Button type="ghost" className="circle"   onClick={()=>  props.updateCurrent(0)}>
                    <ArrowLeft />
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="ant-btn--icon"
                    onClick={onNext}
                    disabled={!valid}
                  >
                    Alıcı Seçin
                    <ArrowRight />
                  </Button>
                </div>
              ) : null}
            </Row>
          </Form>
        </div>
      </div>
  );
};

export default TextMessage;
